import { useMutation, useQueryClient } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { Tarefa } from '../types';

interface TarefaUpsertInput {
  empresa_id: string;
  id?: string;
  payload: Partial<Omit<Tarefa, 'id' | 'empresa_id'>>;
}

export function useTarefaUpsert() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: TarefaUpsertInput) => {
      return n8nFetch<Tarefa>('/tarefa-upsert', {
        method: 'POST',
        body: JSON.stringify(input),
      });
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['tarefas'] });
      qc.invalidateQueries({ queryKey: ['tarefas', { empresa_id: vars.empresa_id }] });
    },
  });
}

export type TarefaAction =
  | 'concluir'
  | 'adiar_1h'
  | 'adiar_1d'
  | 'adiar_7d'
  | 'cancelar'
  | 'reabrir';

export function useTarefaAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, action }: { id: string; action: TarefaAction }) => {
      return n8nFetch<{ id: string; status: string }>('/tarefa-action', {
        method: 'POST',
        body: JSON.stringify({ id, action }),
      });
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['tarefas'] });
    },
  });
}
